export default "__VITE_ASSET__c2b1b6f2__"